import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import "./FeedbackDetailModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
import DetailBox from "../../../components/DetailBox/DetailBox";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const FeedbackDetailModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="75vh" modalWidth="60vw">
      <ModalHeader
        modal={{ modal_title: trans("Feedback Details") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={4}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <DetailBox title={'Feedback For'} subtitle={'Goal'}/>
              <DetailBox title={'Goals'} subtitle={'CB Mobile APp'}/>
              <DetailBox title={'Task'} subtitle={'Mobile Dashboard Design'}/>
              <Box
                style={{
                  backgroundColor: "#FAFAFA",
                  padding: "0.5em",
                  marginTop: "0.7em",
                  borderRadius: "0.6em",
                }}
              >
                <Box>
                  <Typography
                    style={{
                      color: "#0000008A",
                      fontSize: "0.75em",
                      fontFamily: fonts.fontFamily,
                    }}
                  >
                    Feedback
                  </Typography>
                </Box>
                <Box style={{ marginTop: "0.3em" }}>
                  <Typography
                    style={{
                      color: "##000000DE",
                      fontSize: "0.75em",
                      fontFamily: fonts.fontFamily,
                    }}
                  >
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry’s
                    standard dummy text ever since the 1500s,
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
                maxHeight: "50vh",
                height: "auto",
              }}
            >
              <Box
                style={{
                  maxHeight: "38vh",
                  height: "auto",
                  overflowY: "auto",
                }}
              >
                <Box>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <Avatar />
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: "0.75em",
                        marginLeft: "1em",
                      }}
                    >
                      Willa Vargas
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAFAFA",
                      padding: "0.5em",
                      marginTop: "0.5em",
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          color: "#0000008A",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Feedback For
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          color: "##000000DE",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Goal
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        fontSize: "0.75em",
                        color: "#AAAAAA",
                        marginTop: "0.5em",
                      }}
                    >
                      34m ago
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <Avatar />
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: "0.75em",
                        marginLeft: "1em",
                      }}
                    >
                      Willa Vargas
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAFAFA",
                      padding: "0.5em",
                      marginTop: "0.5em",
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          color: "#0000008A",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Feedback For
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          color: "##000000DE",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Goal
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        fontSize: "0.75em",
                        color: "#AAAAAA",
                        marginTop: "0.5em",
                      }}
                    >
                      34m ago
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <Avatar />
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: "0.75em",
                        marginLeft: "1em",
                      }}
                    >
                      Willa Vargas
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAFAFA",
                      padding: "0.5em",
                      marginTop: "0.5em",
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          color: "#0000008A",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Feedback For
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          color: "##000000DE",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Goal
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        fontSize: "0.75em",
                        color: "#AAAAAA",
                        marginTop: "0.5em",
                      }}
                    >
                      34m ago
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <Avatar />
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: "0.75em",
                        marginLeft: "1em",
                      }}
                    >
                      Willa Vargas
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAFAFA",
                      padding: "0.5em",
                      marginTop: "0.5em",
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          color: "#0000008A",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Feedback For
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          color: "##000000DE",
                          fontSize: "0.75em",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        Goal
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        fontSize: "0.75em",
                        color: "#AAAAAA",
                        marginTop: "0.5em",
                      }}
                    >
                      34m ago
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomTextField type="string" label="Comment" rows={4}/>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default FeedbackDetailModalPresenter;
